export default __webpack_public_path__ + "static/media/Thrór's Map - Img - Final (2)_01.373c6dcf.jpg";